// ShopKeeperInformationList.jsx

import { useEffect, useState, useRef } from "react";
import {
  Container,
  Col,
  Row,
  Button,
  Modal,
  Overlay,
  Popover,
} from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "../../../apis/Api";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import storage from "../../../apis/Storage";
import PlaceholderImage from "../../../assets/Images/placeholder-image.png";
import { uploadFile } from "../../../utilities/ImageUpload";
import { getImageExtensions } from "../../../utilities/FUNCTIONS";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { isPermittedPage } from "../../../apis/Utility";
import {
  getDropdownList,
  getDropdownListByPost,
} from "../../Shared/dropdownListActions";
import {
  getWhitlistShopKeeperInformationList,
  UpdateWhitlistShopKeeperInformation,
  downloadJob,
} from "./ShopKeeperInformationListActions";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
} from "../../../Types";

const ShopKeeperInformationList = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const dispatch = useDispatch();
  const formikRef = useRef(null);

  /*----------------- Filters states ---------------*/
  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [filterDistributionID, setFilterDistributionID] = useState(null);
  const [addJobDistributorsOptions, setAddJobDistributorsOptions] = useState(
    [],
  );
  const [addJobDistCenterOptions, setAddJobDistCenterOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const [filter, setfilter] = useState({
    distributorId: null,
    distCenterId: null,
    vizId: "",
    cnic: "",
    kycStatus: null,
    pageNo: 0,
    searchText: "",
    isExport: false,
  });

  /* ---------------- table state ---------------- */
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  /* ---------------- modal ---------------- */
  const [modalShow, setModalShow] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [selectedId, setSelectedId] = useState(null);

  /* ---------------- image upload ---------------- */
  const imgUploadRef = useRef(null);
  const [selectedImgField, setSelectedImgField] = useState(null);

  /* ---------------- helpers ---------------- */
  const WHITELISTING_STATUS_OPTIONS = [
    { label: "Whitelisting Pending", value: "WhitelistingPending" },
    { label: "Whitelisting Approved", value: "WhitelistingApproved" },
    { label: "Whitelisting Rejected", value: "WhitelistingRejected" },
  ];

  const formRequestObject = (isExport = false) => {
    let requestData = {
      distributorId:
        filterDistributorName == null ? null : filterDistributorName.value,
      distCenterId:
        filterDistributionID == null ? null : filterDistributionID.value,
      vizId: filter.vizId || null,
      cnic: filter.cnic || null,
      kycStatus: filter.kycStatus?.value || null,
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText || null,
      isExport: isExport,
    };

    if (
      userRights != null &&
      (userRights.userType === "DistributorUser" ||
        userRights.userType === "CoreAppUser")
    ) {
      requestData.distributorId = userRights.distributorId;
    }

    return requestData;
  };

  const fetchList = () => {
    props.getWhitlistShopKeeperInformationList(formRequestObject());
  };

  useEffect(() => {
    fetchList();
  }, [searchText, currentPageNo, currentPageSize]);

  useEffect(() => {
    setTotalRecords(props.ShopKeeperInformationList?.totalRecords || 0);
  }, [props.ShopKeeperInformationList]);

  const Download = () => {
    let request = formRequestObject(true);
    props.downloadJob(request);
  };

  /* ---------------- table ---------------- */
  const columns = [
    { Header: "VIZ ID", accessor: "vizId" },
    { Header: "Shop Name", accessor: "shopName" },
    { Header: "CNIC", accessor: "cnic" },
    { Header: "Mobile No", accessor: "mobileNumber" },
    { Header: "Full Name", accessor: "fullName" },
    { Header: "Email", accessor: "email" },
    { Header: "Status", accessor: "status" },
    {
      Header: "Action",
      Cell: ({ row: { original } }) => (
        <>
          <button
            className="btn btn-sm"
            onClick={() => viewRecord(original.id)}
          >
            <i className="fas fa-eye" />
          </button>
          &nbsp;
          <button
            className="btn btn-sm"
            onClick={() => editRecord(original.id)}
          >
            <i className="fas fa-edit" />
          </button>
        </>
      ),
    },
  ];

  /* ---------------- Filters ---------------- */
  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
  }, []);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value),
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setAddJobDistributorsOptions(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (
      userRights != null &&
      (userRights?.userType == "DistributorUser" ||
        userRights?.userType == "CoreAppUser")
    ) {
      var assignedDistcenterIds = userRights.distCenterIds.split(",");
      let filteredItems = props.addJobDistCentersddlList.filter((item) =>
        assignedDistcenterIds.includes(item.value),
      );
      setAddJobDistCenterOptions(
        filteredItems.map(function (item) {
          return {
            value: item.value,
            label: item.label,
            principalName: item.principalName,
            cityName: item.cityName,
          };
        }),
      );
    } else {
      setAddJobDistCenterOptions(
        props.addJobDistCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.addJobDistCentersddlList]);

  useEffect(() => {
    if (filterDistributorName) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: filterDistributorName.value },
        GET_DISTRIBUTIONCENTER_DDL,
      );
    }
    filter.distCenter = null;
  }, [filterDistributorName]);

  const kycStatusOptions = [
    { label: "Qualified", value: 1 },
    { label: "Unqualified", value: 2 },
  ];

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributorId: null,
      distCenterId: null,
      vizId: "",
      cnic: "",
      kycStatus: null,
      pageNo: 0,
      searchText: "",
      isExport: false,
    });
    setFilterDistributorName(null);
    setFilterDistributionID(null);
    setAddJobDistCenterOptions([]);
  };

  const LoadDataByfilter = () => {
    setCurrentPageNo(0);
    fetchList();
    setShow(false);
  };

  useEffect(() => {
    if (modalShow && selectedId && formikRef.current) {
      getDetail(selectedId);
    }
  }, [modalShow, selectedId]);

  /* ---------------- view / edit ---------------- */

  const getDetail = async (id) => {
    if (!id || !formikRef.current) return;

    dispatch(showLoading());

    try {
      const { data } = await axios.get(
        `api/WhiteListing/GetWhitlistShopKeeperInformationDetail/${id}`,
      );

      if (data?.response) {
        const r = data.response;
        formikRef.current.setFieldValue("id", r.id);
        formikRef.current.setFieldValue("vizId", r.vizId || "");
        formikRef.current.setFieldValue("shopName", r.shopName || "");
        formikRef.current.setFieldValue("cnic", r.cnic || "");
        formikRef.current.setFieldValue("mobileNumber", r.mobileNumber || "");
        formikRef.current.setFieldValue("fullName", r.fullName || "");
        formikRef.current.setFieldValue("email", r.email || "");
        formikRef.current.setFieldValue("address", r.address || "");
        formikRef.current.setFieldValue("status", r.status || "");

        // images
        formikRef.current.setFieldValue(
          "cnicFrontImageUrl",
          r.cnicFrontImageUrl || "",
        );
        formikRef.current.setFieldValue(
          "cnicBackImageUrl",
          r.cnicBackImageUrl || "",
        );
        formikRef.current.setFieldValue(
          "declarationCertificateUrl",
          r.declarationCertificateUrl || "",
        );
      }
    } catch {
      toast.error("Failed to load information.");
    } finally {
      dispatch(hideLoading());
    }
  };

  const viewRecord = (id) => {
    setReadOnly(true);
    setSelectedId(id);
    setModalShow(true);
  };

  const editRecord = (id) => {
    setReadOnly(false);
    setSelectedId(id);
    setModalShow(true);
  };

  /* ---------------- image handlers ---------------- */
  const openUploadImage = (field) => {
    setSelectedImgField(field);
    imgUploadRef.current.click();
  };

  const saveImage = async (event, setFieldValue) => {
    dispatch(showLoading());
    const file = event.target.files?.[0];
    if (!file) return dispatch(hideLoading());

    const allowed = getImageExtensions();
    const ext = file.name.split(".").pop().toLowerCase();
    if (!allowed.includes(ext)) {
      toast.error("Invalid image type");
      dispatch(hideLoading());
      return;
    }

    try {
      const url = await uploadFile(file);
      setFieldValue(selectedImgField, url);
    } catch {
      toast.error("Image upload failed");
    }

    imgUploadRef.current.value = "";
    dispatch(hideLoading());
  };

  const removeImage = (fieldName, setFieldValue) => {
    setFieldValue(fieldName, null);
    if (imgUploadRef.current) imgUploadRef.current.value = "";
  };

  /* ---------------- submit ---------------- */
  const updateHandler = async (values) => {
    // ;
    await props.UpdateWhitlistShopKeeperInformation(values);
    setModalShow(false);
    fetchList();
  };

  /* ---------------- validation ---------------- */
  const validationSchema = Yup.object({
    shopName: Yup.string().required("Shop Name is Required"),
    cnic: Yup.string().required("CNIC is Required"),
    fullName: Yup.string().required("Full Name is Required"),
    mobileNumber: Yup.string().required("Mobile Number is Required"),
    email: Yup.string().required("Email is Required"),
    address: Yup.string().required("Address is Required"),
    status: Yup.string().required("Status is Required"),
  });

  return (
    <VzPageContainer title="ShopKeeper Information List">
      <Row>
        <Col md={10} style={{ float: "right" }}>
          <div ref={ref}>
            <Button
              onClick={openFilterModal}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-filter" />
              Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
              width="430px"
              style={{ width: "430px" }}
            >
              <Popover
                id="popover-contained"
                style={{ maxWidth: "360px", width: "360px" }}
              >
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik
                    enableReinitialize
                    initialValues={{}}
                    validator={() => ({})}
                    onSubmit={(e) => LoadDataByfilter(e)}
                  >
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distributor"
                              name="distributorName"
                              options={addJobDistributorsOptions}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  setFilterDistributionID(null);
                                  setFilterDistributorName(null);
                                  return;
                                }
                                setFilterDistributorName({
                                  label: e.label,
                                  value: e.value,
                                });
                                setFilterDistributionID(null);
                              }}
                              value={filterDistributorName}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution Center"
                              name="distCenterId"
                              options={addJobDistCenterOptions}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  setFilterDistributionID(null);

                                  return;
                                }
                                setFilterDistributionID({
                                  label: e.label,
                                  value: e.value,
                                });
                              }}
                              value={filterDistributionID}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="text"
                              label="Viz ID"
                              name="vizId"
                              handleOnChange={(e) => {
                                filter.vizId = e;
                                setfilter({ ...filter, vizId: e });
                              }}
                              value={filter.vizId}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="text"
                              label="CNIC"
                              name="cnic"
                              handleOnChange={(e) => {
                                filter.cnic = e;
                                setfilter({ ...filter, cnic: e });
                              }}
                              value={filter.cnic}
                            />
                          </Col>

                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="WhiteListing Status"
                              name="status"
                              options={kycStatusOptions}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  return;
                                }
                                setfilter({
                                  ...filter,
                                  kycStatus: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                });
                              }}
                              value={filter.kycStatus}
                            />
                          </Col>
                        </Row>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="form-group">
                            <Link
                              onClick={handleResetFilters.bind(
                                null,
                                formik.resetForm,
                              )}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "left",
                              }}
                            >
                              Reset
                            </Link>
                            <Link
                              onClick={() => {
                                setShow(false);
                                setTarget(null);
                              }}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "right",
                              }}
                            >
                              Cancel
                            </Link>
                            <div className="float-right">
                              <Button
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  marginRight: "10px",
                                  float: "right",
                                }}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>
        {isPermittedPage("Export", props.actions, props.userRole) && (
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={Download}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-download me-1" />
              Export
            </Button>
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          <ServerSideDataTable
            data={props.ShopKeeperInformationList?.data ?? []}
            columns={columns}
            totalRecords={totalRecords}
            pageNo={currentPageNo}
            myPageSize={currentPageSize}
            goToNextPage={setCurrentPageNo}
            goToPreviousPage={setCurrentPageNo}
            pageSizeChange={setCurrentPageSize}
            searchChanged={setSearchText}
          />
        </Col>
      </Row>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        backdrop="static"
      >
        <Formik
          innerRef={formikRef}
          initialValues={{
            id: "",
            vizId: "",
            shopName: "",
            cnic: "",
            mobileNumber: "",
            fullName: "",
            email: "",
            address: "",
            status: "",
            cnicFrontImageUrl: "",
            cnicBackImageUrl: "",
            declarationCertificateUrl: "",
          }}
          validationSchema={validationSchema}
          onSubmit={updateHandler}
        >
          {(formik) => {
            const { values, setFieldValue } = formik;

            return (
              <Form>
                <input type="hidden" name="id" value={formik.values.id || ""} />
                <Modal.Body>
                  <Container>
                    <Row>
                      <Col>
                        <div className="card-header">
                          <h3>
                            <b>ShopKeeper Information Detail:</b>
                          </h3>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={8}>
                        <Row>
                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="VIZ ID"
                              name="vizId"
                              readOnly
                              value={formik.values.vizId ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("vizId", v)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="Shop Name"
                              name="shopName"
                              readOnly={readOnly}
                              value={formik.values.shopName ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("shopName", v)
                              }
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="CNIC"
                              name="cnic"
                              readOnly={readOnly}
                              value={formik.values.cnic ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("cnic", v)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="Mobile No"
                              name="mobileNumber"
                              readOnly={readOnly}
                              value={formik.values.mobileNumber ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("mobileNumber", v)
                              }
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="Full Name"
                              name="fullName"
                              readOnly={readOnly}
                              value={formik.values.fullName ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("fullName", v)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <FormikControl
                              formik={formik}
                              control="input"
                              label="Email"
                              name="email"
                              readOnly={readOnly}
                              value={formik.values.email ?? ""}
                              handleOnChange={(v) =>
                                formik.setFieldValue("email", v)
                              }
                            />
                          </Col>
                        </Row>

                        <Col md={12}>
                          <FormikControl
                            formik={formik}
                            control="input"
                            label="Address"
                            name="address"
                            readOnly={readOnly}
                            value={formik.values.address ?? ""}
                            handleOnChange={(v) =>
                              formik.setFieldValue("address", v)
                            }
                          />
                        </Col>

                        <Col md={12}>
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            label="Status"
                            name="status"
                            options={WHITELISTING_STATUS_OPTIONS}
                            value={WHITELISTING_STATUS_OPTIONS.find(
                              (x) => x.value === formik.values.status,
                            )}
                            handleOnChange={(opt) => {
                              if (!opt) return;
                              formik.setFieldValue("status", opt.value);
                            }}
                            isDisabled={true}
                            disabled={true}
                          />
                        </Col>
                      </Col>

                      <Col md={4}>
                        {[
                          { label: "CNIC Front", key: "cnicFrontImageUrl" },
                          { label: "CNIC Back", key: "cnicBackImageUrl" },
                          {
                            label: "Declaration Certificate",
                            key: "declarationCertificateUrl",
                          },
                        ].map((img) => (
                          <div key={img.key} className="text-center mb-3">
                            <p>{img.label}</p>
                            <img
                              className="kyc-form-img"
                              src={
                                values?.[img.key]
                                  ? values[img.key]
                                  : PlaceholderImage
                              }
                              width="200"
                              height="125"
                              alt="img"
                            />

                            {!readOnly && (
                              <div>
                                <button
                                  type="button"
                                  onClick={() => openUploadImage(img.key)}
                                  className="btn btn-sm"
                                >
                                  <i className="fas fa-edit" />
                                </button>

                                <button
                                  type="button"
                                  onClick={() =>
                                    removeImage(img.key, setFieldValue)
                                  }
                                  className="btn btn-sm"
                                >
                                  <i className="fas fa-trash" />
                                </button>
                              </div>
                            )}
                          </div>
                        ))}

                        <input
                          hidden
                          ref={imgUploadRef}
                          type="file"
                          accept="image/*"
                          onChange={(e) => saveImage(e, setFieldValue)}
                        />
                      </Col>
                    </Row>
                  </Container>
                </Modal.Body>

                <Modal.Footer>
                  {!readOnly && <Button type="submit">Save</Button>}
                  <Button
                    variant="secondary"
                    onClick={() => setModalShow(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </VzPageContainer>
  );
};

const mapStateToProps = (state) => ({
  ShopKeeperInformationList: state.ShopKeeperInformationList,
  allDistributorList: state.ddlList.allDistributorList
    ? state.ddlList.allDistributorList
    : [],
  addJobDistCentersddlList: state.ddlList?.selectedDistCentersList || [],
});

export default connect(mapStateToProps, {
  getWhitlistShopKeeperInformationList,
  UpdateWhitlistShopKeeperInformation,
  getDropdownList,
  getDropdownListByPost,
  downloadJob,
})(ShopKeeperInformationList);
